<template>
    <el-dialog
        :top='top'
        :title="title"
        :visible.sync="visible"
        :close-on-click-modal='clickModel'
        :width="width"
        :custom-class="customClass"
        :append-to-body="true"
        :show-close="closeShow"
        :before-close="handleClose">
        <slot name="content"></slot>
        <span slot="footer" class="dialog-footer">
            <slot name="footer"></slot>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            title: {
                type: [Number, String],
                default: ''
            },
            visible: {
                type: Boolean,
                default: false
            },
            top: {
                type: String,
                default: '5vh'
            },
            clickModel: {
                type: Boolean,
                default: false
            },
            width: {
                type: String,
                default: '80%'
            },
            customClass: {
                type: String,
                default: ''
            },
            closeShow: {
                type: Boolean,
                default: true
            },
        },
        methods: {
            handleClose() {
                this.$emit('handleClose')
            }
        }
    }
</script>

<style>

</style>